import * as React from 'react';
import { Icon, Stack } from '@fluentui/react';
import Divider from '@mui/material/Divider';
import { CmicContext } from '../context/CmicContext';
import { THEME_ID, baseFontFamilyStyle } from '../shared/styles';

export const handleTHEMECLR = currentOfficeTheme => {
	const theme = currentOfficeTheme?.themeId ? currentOfficeTheme?.themeId : THEME_ID.WHITE;

	switch (theme) {
		case THEME_ID.WHITE:
		case THEME_ID.COLORFUL:
			return 'iconContainer_light';
		case THEME_ID.DARK_GREY:
			return 'iconContainer_grey';
		case THEME_ID.BLACK:
			return 'iconContainer_dark';
		default:
			return 'iconContainer_dark';
	}
};

export const handleFRONTCLR = currentOfficeTheme => {
	const theme = currentOfficeTheme?.themeId ? currentOfficeTheme?.themeId : THEME_ID.WHITE;

	switch (theme) {
		case THEME_ID.WHITE:
		case THEME_ID.COLORFUL:
			return '#5E6367';
		case THEME_ID.DARK_GREY:
			return '#4b4b4b';
		case THEME_ID.BLACK:
			return '#CDCDCD';
		default:
			return '#5E6367';
	}
};

export const handleBGCLR = currentOfficeTheme => {
	const theme = currentOfficeTheme?.themeId ? currentOfficeTheme?.themeId : THEME_ID.WHITE;

	switch (theme) {
		case THEME_ID.WHITE:
		case THEME_ID.COLORFUL:
			return '#ffffff';
		case THEME_ID.DARK_GREY:
			return '#D4D4D4';
		case THEME_ID.BLACK:
			return '#262626';
		default:
			return '#5E6367';
	}
};

const BorderImage = ({
	size = '30wh',
	label = '',
	description = '',
	isDefaultIcon = true,
	IconProp = null,
	iconName,
	iconStyle,
	parentClass = '',
	parentStyles,
	onClick,
	...parentOthers
}) => {
	const { currentOfficeTheme } = React.useContext(CmicContext);

	const stackItemStyles = {
		root: {
			alignItems: 'center',
			justifyContent: 'center',
			backgroundColor: handleBGCLR(currentOfficeTheme),
			border: `1px solid ${
				currentOfficeTheme.themeId === THEME_ID.BLACK
					? currentOfficeTheme.bodyForegroundColor
					: 'rgba(174, 180, 189, 1)'
			}`,
			padding: '1rem 0.5rem',
			cursor: 'pointer',
			margin: '0.2rem 0.25rem',
			flex: 1,
			display: 'flex',
			width: size,
		},
	};

	const imageContainer = {
		color: handleFRONTCLR(currentOfficeTheme),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		textAlign: 'center',
		width: '100%',
	};

	const headerTextStyle = {
		fontSize: '12px',
		fontWeight: 'normal',
		fontFamily: baseFontFamilyStyle,
		color: currentOfficeTheme.bodyForegroundColor,
		marginTop: '0.5rem',
		color: 'currentColor',
	};

	const textStyle = {
		fontSize: '8px',
		fontWeight: 'light',
		horizontalAlign: 'left',
		fontFamily: baseFontFamilyStyle,
		color: 'currentColor',
	};

	const iconStackStyles = {
		root: { fontSize: 20, color: 'currentColor' },
	};

	const requiredTheme = `${handleTHEMECLR(currentOfficeTheme)}`;

	return (
		<Stack
			className={requiredTheme}
			onClick={onClick}
			styles={stackItemStyles}
			style={parentStyles}
			tokens={{ childrenGap: 10 }}
			{...parentOthers}
		>
			<Stack style={imageContainer}>
				{isDefaultIcon ? (
					<Icon style={iconStyle} iconName={iconName} styles={iconStackStyles} />
				) : (
					<span className="material-symbols-outlined">{iconName}</span>
				)}
				<strong style={headerTextStyle}>{label}</strong>
			</Stack>

			{description && (
				<Stack.Item
					style={{
						display: 'flex',
						alignItems: 'flex-start',
						justifyContent: 'center',
						flexDirection: 'column',
					}}
				>
					<Divider style={{ borderColor: currentOfficeTheme.controlForegroundColor, opacity: 0.25 }} />
					<strong style={textStyle}>{description}</strong>
				</Stack.Item>
			)}
		</Stack>
	);
};

export default BorderImage;
